import { FETCH_HARDWARE_BOARD_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const hardwareBoardListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HARDWARE_BOARD_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default hardwareBoardListReducer;
